import { Button, DialogActions, DialogContent } from "@mui/material";
import l10n from "@src/v3.0.0/lib/l10n";
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

export default function ActionResetDialog(resolve, reject, onClose) {
  return (
    <>
      <DialogContent>
        <div
          dangerouslySetInnerHTML={{ __html: l10n.wppr_cjs_ctrl_reset_text }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} startIcon={<CloseIcon />}>
          ANNULLA
        </Button>
        <Button
          onClick={() => resolve()}
          startIcon={<CheckIcon />}
          variant="outlined">
          CONFERMA
        </Button>
      </DialogActions>
    </>
  );
}
